export default __webpack_public_path__ + "static/media/question_05.138a176e.png";